module.exports = __webpack_public_path__ + "static/media/db-logo.1c9e9aa0.jpg";